import { Injectable } from '@angular/core';
export class BsModalRef {
    constructor() {
        /**
           * Hides the modal
           */
        this.hide = Function;
    }
}
BsModalRef.decorators = [
    { type: Injectable },
];
//# sourceMappingURL=bs-modal-ref.service.js.map